/** Compact display only; never use the result as a scale/domain value. */
export const formatCompactNumber = (value: number, precision = 1): string => {
  const magnitude = Math.abs(value);
  // Promote rounded thousands to millions instead of displaying 1000k.
  if (magnitude >= 999950) return `${Number((value / 1000000).toFixed(precision))}M`;
  if (magnitude >= 999.95) return `${Number((value / 1000).toFixed(precision))}k`;
  return String(Number(value.toFixed(precision)));
};

/** Use enough shared precision to distinguish the actual numeric ticks. */
export const formatNumericTicks = (values: number[]): string[] => {
  for (let precision = 1; precision <= 15; precision += 1) {
    const labels = values.map(value => formatCompactNumber(value, precision));
    const identities = new Map<string, number>();
    const readable = labels.every((label, index) => {
      const value = values[index];
      if (value !== 0 && Number.parseFloat(label) === 0) return false;
      if (identities.has(label) && identities.get(label) !== value) return false;
      identities.set(label, value);
      return true;
    });
    if (readable) return labels;
  }
  return values.map(String);
};
